import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import classNames from 'classnames';
import Button from 'material-ui/Button';
import Human from '../../Icons/Human';
import { TimelineLabelType } from '../../../constants/ComponentTypes';
import moment from "moment";
import { connect } from 'react-redux';

const styles = () => ({
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    backgroundColor: '#FFFFFF',
    '-webkit-box-shadow': '0px 0px 3px 0px rgba(0,0,0,0.15)',
    '-moz-box-shadow': '0px 0px 3px 0px rgba(0,0,0,0.15)',
    boxShadow: '0px 0px 3px 0px rgba(0,0,0,0.15)',
  },

  flex: {
    flex: 1,
  },

  container: {
    width: "calc(100% - 250px)",
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '44px 0',
  },

  keymanName: {
    fontSize: '14px',
  },

  position: {
    color: '#71737B',
    fontSize: '11px',
  },

  rightContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: '35px',
  },

  icon: {
    boxSizing: 'border-box',
    background: '#F2F6F9',
    width: '38px',
    height: '38px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '12px',
  },

  keymanContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  keymanAttribute: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flexStart',
  },

  reactionDetail: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '48px',
  },

  reactionStatus: {
    color: '#9D81FF',
    fontSize: '11px',
    marginRight: '20px',
  },

  reactionAt: {
    color: '#7C7C7C',
    fontSize: '11px',
  },

  name: {
    color: '#181819',
    fontSize: '13px',
    fontWeight: 'bold'
  },

  btns: {
    display: 'flex',
  },

  btn: {
    padding: '10px 18px',
    height: "33px",
    borderRadius: "2px",
    fontSize: "13px",
  },

  btnDisable: {
    border: "1px solid #ECEDEF",
    background: "#ECEDEF",
    color: "#000000",
  },

  btnEnable: {
    border: "1px solid #1A65FF",
    background: "#FFFFFF",
    color: "#1A65FF",
    "&:hover": {
      background: "#1A65FF",
      color: '#FFFFFF',
    },
  }
});

class KeymanIntroduction extends React.Component {
  getKeymanName = () => {
    const { item, statuses } = this.props;

    if (!item) {
      // itemがない場合（ESにデータがない場合）は、statusesから最新のものを取得する
      if (Array.isArray(statuses) && statuses.length > 0) {
        const reversedStatuses = statuses.slice().reverse();

        for (let i = 0; i < reversedStatuses.length; i++) {
          const status = reversedStatuses[i];
          if (status && status.letter_order_address && status.letter_order_address.name) {
            return status.letter_order_address.name + " 様";
          }
          if (status && status.follow_call_order_address && status.follow_call_order_address.name) {
            return status.follow_call_order_address.name + " 様";
          }
        }
      }

      return "";
    }

    return item.name + " 様";
  }

  getKeymanAttribute = () => {
    const { item, isExeTimeline, statuses } = this.props;

    if (!item) {
      // itemがない場合（ESにデータがない場合）は、statusesから最新のものを取得する
      if (Array.isArray(statuses) && statuses.length > 0) {
        const reversedStatuses = statuses.slice().reverse();

        for (let i = 0; i < reversedStatuses.length; i++) {
          const status = reversedStatuses[i];
          if (status && status.letter_order_address && status.letter_order_address.name) {
            return status.letter_order_address.company + " " + status.letter_order_address.position;
          }
          if (status && status.follow_call_order_address && status.follow_call_order_address.name) {
            // フォローコールアドレスの場合はpositionがnullで登録できるので値があれば表示する
            return status.follow_call_order_address.company + (status.follow_call_order_address.position ? " " + status.follow_call_order_address.position : '');
          }
        }
      }

      return "";
    }

    if (isExeTimeline) {
      return item.company_name + " " + item.honorific;
    } else {
      // フォローコールアドレスの場合はpositionがnullで登録できるので値があれば表示する
      return item.company + (item.position ? " " + item.position : '');
    }
  }

  renderKeymanAttribute = () => {
    const { classes } = this.props;

    return (
      <div className={classes.keymanContainer}>
        <div className={classes.icon}>
          <Human width={20} height={20} color="#7C8297" />
        </div>
        <div className={classes.keymanAttribute}>
          <div className={classes.keymanName}>{this.getKeymanName()}</div>
          <div className={classes.position}>{this.getKeymanAttribute()}</div>
        </div>
      </div>
    );
  }

  renderReactionDetail = () => {
    const { statuses, classes } = this.props;
    const reactionTimeline = statuses.find(item => item.status_label_type === TimelineLabelType.QR_CODE_REACTION.value);

    return (
      <div className={classes.reactionDetail}>
        <div className={classes.reactionStatus}>{"QRコードリアクション" + (reactionTimeline ? "あり" : "なし")}</div>
        {reactionTimeline && (
          <div className={classes.reactionAt}>
            {moment(reactionTimeline.created_at).format("YYYY/MM/DD")}
          </div>
        )}
      </div>
    );
  }

  renderButtons = () => {
    const { classes, statuses } = this.props;
    const lastLetterOrderStatus = statuses.filter(
      item =>
        item.letter_order_address &&
        item.letter_order_address.letter_order &&
        item.letter_order_address.letter_order.order
    ).pop();

    return (
      <div className={classes.btns}>
        {lastLetterOrderStatus && (
          <Button className={classNames(classes.btn, classes.btnEnable)} style={{ marginRight: "11px" }} onClick={() => this.props.toggleLetterOrderDetailDialog(lastLetterOrderStatus)}>
            最終レター注文詳細
          </Button>
        )}
        {this.props.isExeTimeline && this.props.item && (
          <Button className={classNames(classes.btn, classes.btnEnable)} style={{ marginRight: "11px" }} onClick={() => this.props.toggleExecDetailItemDialog()}>
            キーマン詳細
          </Button>
        )}
      </div>
    );
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.flex}></div>
        <div className={classes.container}>
          {this.renderKeymanAttribute()}
          <div className={classes.rightContainer}>
            {this.renderReactionDetail()}
            {this.renderButtons()}
          </div>
        </div>
      </div>
    )
  }
}

KeymanIntroduction.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleLetterOrderDetailDialog: PropTypes.func.isRequired,
  toggleExecDetailItemDialog: PropTypes.func.isRequired,
  isExeTimeline: PropTypes.bool,
  item: PropTypes.object,
  statuses: PropTypes.array,
};

const mapStateToProps = (state) => {
  const isExeTimeline = state.router.location.pathname.includes("executive-list");
  return {
    isExeTimeline: isExeTimeline,
    item: isExeTimeline ? state.executiveDetail.item : state.addressDetail.contact,
    statuses: state.timeline.statuses.toIndexedSeq().toArray(),
  };
};

PropTypes.defaultProps = {
  isExeTimeline: false,
};

export default withStyles(styles)(connect(
  mapStateToProps
)(KeymanIntroduction));



// WEBPACK FOOTER //
// ./src/components/Timeline/sections/KeymanIntroductionSection.jsx